export const HEADER = "Let's get your business set up";
